import { gql } from '@apollo/client';

export const NOTIFICATIONS_PAGE_QUERY = gql`
  query notifications(
    $limit: Int!
    $offset: Int!
    $q: String
    $withDeleted: Boolean
    $orderBy: String
    $orderDirection: String
    $columnFilters: [ColumnFilter!]
  ) {
    notifications(
      limit: $limit
      offset: $offset
      q: $q
      withDeleted: $withDeleted
      orderBy: $orderBy
      orderDirection: $orderDirection
      columnFilters: $columnFilters
    ) {
      id
      name
      publishDate
      expirationDate
      type
      text
      notificationCountryIds
      notificationStateProvinceIds
      notificationUserIds
      notificationCustomerIds
      deletedAt
    }
    notificationsPageInfo(
      q: $q
      columnFilters: $columnFilters
      withDeleted: $withDeleted
    ) {
      totalCount
    }
  }
`;

export const NOTIFICATIONS_QUERY = gql`
  query notifications($limit: Int!, $offset: Int!, $q: String, $withDeleted: Boolean) {
    notifications(limit: $limit, offset: $offset, q: $q, withDeleted: $withDeleted) {
      id
      name
      publishDate
      expirationDate
      type
      text
      notificationCountryIds
      notificationStateProvinceIds
      notificationUserIds
      notificationCustomerIds
      deletedAt
    }
  }
`;

export const NOTIFICATION_QUERY = gql`
  query notification($id: Int!) {
    notification(id: $id) {
      id
      name
      publishDate
      expirationDate
      type
      text
      notificationCountryIds
      notificationStateProvinceIds
      notificationUserIds
      notificationCustomerIds
      deletedAt
    }
  }
`;

export const MY_NOTIFICATIONS_QUERY = gql`
  query myNotifications {
    myNotifications {
      id
      text
      type
      publishDate
      readedAt
    }
  }
`;

export const NOTIFICATION_AFFECTED_USERS_QUERY = gql`
  query notificationAffectedUsers(
    $countryIds: [Int!]!
    $stateProvinceIds: [Int!]!
    $userIds: [Int!]!
    $customerIds: [Int!]!
  ) {
    notificationAffectedUsers(
      countryIds: $countryIds
      stateProvinceIds: $stateProvinceIds
      userIds: $userIds
      customerIds: $customerIds
    )
  }
`;
